import { useMemo } from 'react'

import { cleanString, purgeWidowsAndOrphans } from 'shared/utils/common'

type FormattedTextProps = {
  text?: string
}

// This component formats text string from external sources.
const FormattedText = ({ text }: FormattedTextProps) => {
  const formatted = useMemo(() => {
    if (!text) return ''
    const cleanedText = cleanString(text)
    const formattedText = purgeWidowsAndOrphans(cleanedText)

    return formattedText
  }, [text])

  return <>{formatted}</>
}

export default FormattedText
